var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      staticClass: "base-self-filter-toggle__tip",
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "BaseButton",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "base-self-filter-toggle",
                      class: { "az-highlight-pulse": _vm.highlight },
                      style: _vm.highlightStyle,
                      attrs: {
                        primary: _vm.active && !_vm.disabled,
                        bordered: !_vm.active || _vm.disabled,
                        fitContent: "",
                        loading: _vm.loading,
                        disabled: _vm.disabled,
                        "aria-pressed": _vm.active ? "true" : "false",
                        "aria-label": _vm.ariaLabel
                      },
                      on: { click: _vm.onClick }
                    },
                    "BaseButton",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("icon-svg", {
                    attrs: { name: "user-2", size: 18, color: "currentColor" }
                  }),
                  _vm._v(" " + _vm._s(_vm.label) + " ")
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [_c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }